package com.partejar.app.feature.gestantes.presentation

import com.partejar.app.feature.gestantes.data.GestanteListItemData
import com.partejar.app.feature.gestantes.data.GestanteListStage

sealed interface GestantesUiState {
    data object Loading : GestantesUiState
    data class Content(
        val items: List<GestanteListItemData>,
        val totalElements: Long,
        val hasNextPage: Boolean,
        val isRefreshing: Boolean = false,
        val isLoadingNextPage: Boolean = false,
        val nextPageError: String? = null
    ) : GestantesUiState
    data class Empty(val hasActiveSearch: Boolean) : GestantesUiState
    data class Error(val message: String) : GestantesUiState
}

val DefaultGestanteStages: Set<GestanteListStage> = setOf(GestanteListStage.ACTIVE)
